import { Graphics } from 'pixi.js';

// Drifting nebula clouds rendered behind the title-screen menu — additive soft-glow blobs
// with breathing scale + lissajous wobble + edge-wrap. Visual-only, no gameplay impact.
interface Cloud {
  x: number; y: number;        // 0..1 viewport-relative
  vx: number; vy: number;
  r: number;
  col: number;
  a: number;                   // base alpha
}

export class TitleNebula {
  view: Graphics;
  private clouds: Cloud[] = [
    { x: 0.18, y: 0.30, vx:  0.018, vy:  0.008, r: 320, col: 0x4488ff, a: 0.07 },
    { x: 0.62, y: 0.18, vx: -0.022, vy:  0.012, r: 380, col: 0xff44cc, a: 0.06 },
    { x: 0.40, y: 0.78, vx:  0.014, vy: -0.010, r: 420, col: 0x44ddff, a: 0.05 },
    { x: 0.86, y: 0.62, vx: -0.018, vy: -0.006, r: 300, col: 0xffaa44, a: 0.06 },
    { x: 0.10, y: 0.85, vx:  0.026, vy:  0.014, r: 260, col: 0xffffff, a: 0.04 },
  ];

  constructor() {
    this.view = new Graphics();
    this.view.blendMode = 'add';
    this.view.visible = false;
  }

  setVisible(visible: boolean): void {
    this.view.visible = visible;
  }

  render(W: number, H: number, dt: number, introEased: number): void {
    this.view.clear();
    const nebT = Date.now() * 0.001;
    for (let i = 0; i < this.clouds.length; i++) {
      const c = this.clouds[i];
      c.x += c.vx * dt * 0.4;
      c.y += c.vy * dt * 0.4;
      if (c.x < -0.3) c.x = 1.3;
      if (c.x >  1.3) c.x = -0.3;
      if (c.y < -0.3) c.y = 1.3;
      if (c.y >  1.3) c.y = -0.3;
      // Breathing scale — each cloud has its own phase
      const breath = 0.85 + 0.20 * Math.sin(nebT * 0.35 + i * 1.7);
      // Lateral wobble — small lissajous to break the rigid drift
      const wobX = Math.sin(nebT * 0.25 + i * 2.3) * 18;
      const wobY = Math.cos(nebT * 0.31 + i * 1.1) * 14;
      const px = c.x * W + wobX;
      const py = c.y * H + wobY;
      const rr = c.r * breath;
      // 4-layer falloff for soft volumetric glow
      this.view.circle(px, py, rr * 1.15);
      this.view.fill({ color: c.col, alpha: c.a * 0.20 * introEased });
      this.view.circle(px, py, rr * 0.85);
      this.view.fill({ color: c.col, alpha: c.a * 0.40 * introEased });
      this.view.circle(px, py, rr * 0.55);
      this.view.fill({ color: c.col, alpha: c.a * 0.70 * introEased });
      this.view.circle(px, py, rr * 0.28);
      this.view.fill({ color: c.col, alpha: c.a * 1.10 * introEased });
    }
  }
}
